import { useParams } from "react-router-dom";
import { useTicketByIdQuery } from "@/hooks/api/ticket.queries";
import TicketDetailView from "@/components/TicketDetailView";
import { Spinner, ErrorMessage } from "@/components";

const TicketsView = () => {
  const { id } = useParams<{ id: string }>();
  const { data: ticket, isLoading, error } = useTicketByIdQuery(id || "");

  if (isLoading) return <Spinner />;
  if (error || !ticket)
    return <ErrorMessage message="Ticket not found or failed to load." />;

  return <TicketDetailView ticket={ticket} />;
};

export default TicketsView;
